<style lang="scss" scoped>
.notice__page .date {
  margin-top: 0.2rem;
}
</style>

<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="main__page">
          <div class="title">고객사 목록</div>
          <div class="p16">
            <form class="search">
              <input type="search" placeholder="검색어를 입력하세요." title="" v-model="searchText" v-on:keydown.enter="$event.preventDefault()">
              <button type="reset" @click="searchText = ''" v-show="searchText.trim().length > 0"></button><!--★ 텍스트가 입력되면 보여지고, 버튼을 클릭하면 사라지게 작업해주세요 구글 검색창 참고해주세요! ★-->
            </form>
          </div>
          <div class="complete" v-if="mappingList.length <= 0">
            <img src="@/assets/static/images/img_notice.svg" alt="" class="complete__img">
            <p class="complete__txt__type02">내역이 없습니다.</p>
          </div>
          <div class="notice__page" v-else>
            <ul class="notice__page__ul" v-if="searchList.length > 0">
              <li class="notice__page__li type_02" v-for="(item, index) in searchList" :key="index" @click="reportList(item)">
                <div class="txt">
                  <p>{{ item.companyName }}</p>
                  <p class="date" v-if="item.customerType === 1">{{ `고객번호 : ${ item.customerNumber1 }` }}</p>
                  <p class="date" v-if="item.customerType === 2">{{ `고객번호 : ${ item.customerNumber1 } &nbsp; ${item.customerNumber2}` }}</p>
                  <p class="date">{{ `${item.companyAddress1} ${item.companyAddress2}` }}</p>
                  <p class="date">담당자 : {{ item.contactName }} &nbsp; 연락처 : {{ item.contactPhone }}</p>
                </div>
                <i class="i_right"></i>
              </li>
            </ul>
            <ul class="notice__page__ul" v-else>
              <li class="notice__page__li type_02" v-for="(item, index) in mappingList" :key="index" @click="reportList(item)">
                <div class="txt">
                  <p>{{ item.companyName }}</p>
                  <p class="date" v-if="item.customerType === 1">{{ `고객번호 : ${ item.customerNumber1 }` }}</p>
                  <p class="date" v-if="item.customerType === 2">{{ `고객번호 : ${ item.customerNumber1 } &nbsp; ${item.customerNumber2}` }}</p>
                  <p class="date">{{ `${item.companyAddress1} ${item.companyAddress2}` }}</p>
                  <p class="date">담당자 : {{ item.contactName }} &nbsp; 연락처 : {{ item.contactPhone }}</p>
                </div>
                <i class="i_right"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: function () {
    return {
      searchText: '',
      pageInfo: {},
      mappingList: [],
      searchList: [],
      params: {
        userNo: this.$store.getters['account/getUserData'].userNo,
        page: 1,
        limit: 99999
      }
    }
  },
  watch: {
    searchText: function (value) {
      this.searchList = []
      if (value.trim().length <= 0) {
        return false
      }
      this.mappingList.filter(userData => {
        if (userData.companyName.indexOf(value) >= 0) {
          this.searchList.push(userData)
        }
        if (userData.companyAddress1.indexOf(value) >= 0) {
          this.searchList.push(userData)
        }
        if (userData.contactName.indexOf(value) >= 0) {
          this.searchList.push(userData)
        }
        if (userData.contactPhone.indexOf(value) >= 0) {
          this.searchList.push(userData)
        }
        if (userData.customerNumber1.indexOf(value) >= 0 || userData.customerNumber2.indexOf(value) >= 0) {
          this.searchList.push(userData)
        }
      })


    }
  },
  created: function () {
    this.getMappingUserListData()
  },
  methods: {
    getMappingUserListData: async function () {
      const res = await this.$AssetSvc.getMappingUserListData(this.params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.pageInfo = entity.pageInfo
        this.mappingList = entity.list
      }
    },
    reportList: function (item) {
      this.$router.push({
        path: '/main/reportMiddle',
        query: {
          userNo: item.userNo,
          companyName: item.companyName
        }
      })
    }
  }
}
</script>
